<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">v {{version}}</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">Made with <span style="color: darkred">&#10084;</span>

            by <a href="https://fluidtechglobal.com" target="_blank">FluidTech Global</a> </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
<script>
export default {
  data(){
    return {
      version: process.env.VUE_APP_CURRENT_VERSION
    }
  },
}
</script>
